/**
 * Badge Component
 */

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import './styles.scss';

import Label from '../../text/Label';

interface IOwnProps {
  className?: string;
  label: string;
  colorScheme?: 'white' | 'light' | 'red';
  variant?: 'normal' | 'notification';
}

const classes = new BEM('badge');

export default class Badge extends React.Component<IOwnProps, {}> {
  static defaultProps: Partial<IOwnProps> = {
    colorScheme: 'white',
    variant: 'normal',
  };

  render() {
    const {
      className,
      label,
      variant,
    } = this.props;

    const colorScheme = variant === 'notification' ? 'red' : this.props.colorScheme!;

    const classModifiers = {
      [colorScheme]: true,
      [variant!]: true,
    };

    return (
      <div {...classes('', classModifiers, className) }>
        <Label size="small" WrappedComponent="span" {...classes('label') }>{label}</Label>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/atoms/feedback/Badge/index.tsx